import React, { useState } from 'react';
import { Dialog, Form, Input, MessagePlugin } from 'tdesign-react';
import styled from 'styled-components';
import { createSubscription } from '@/services/topicService';
import Text from '@/components/Text';
import formRulePattern from '@/utils/formRulePattern';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';
import { deal70101 } from '@/utils/common';

const { FormItem } = Form;

export default function Modal({ visible, handleClose, commonProps }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const confirmButton = useDisableButton({ loading: submitting, content: '确定' });

  const onCancel = () => {
    handleClose();
  };

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        const { meta } = await createSubscription({
          ...commonProps,
          ...fields,
        });
        // 主集群创建的资源已在灾备集群存在
        if (meta.code === 70101) {
          deal70101(meta.publicMessage, () => handleSubmit({ validateResult, fields }), {
            url: '/cluster/utils/message',
            subscription: fields.subscription,
          });
          return;
        }
        MessagePlugin.success('操作成功！请稍后');

        handleClose(true);
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Root
      onConfirm={() => form.submit()}
      confirmBtn={confirmButton}
      visible={visible}
      header='创建订阅'
      destroyOnClose
      width={600}
      onClose={onCancel}
    >
      <Form
        form={form}
        onSubmit={handleSubmit}
        initialData={commonProps}
        style={{ width: '94%' }}
        labelWidth={180}
      >
        <FormItem name='clusterName' label='集群名称'>
          <Text />
        </FormItem>
        <FormItem name='topic' label='Topic'>
          <Text />
        </FormItem>
        <FormItem
          name='subscription'
          label='订阅名'
          rules={[{ required: true }, formRulePattern('name')]}
        >
          <Input clearable />
        </FormItem>
      </Form>
    </Root>
  );
}

const Root = styled(Dialog)`
  .t-input-number {
    width: auto;
    flex: 1;
  }
  .t-input__suffix {
    color: var(--td-font-gray-2);
  }
`;
